import { Badge, BadgeSizes, TableCellTypes } from '@carboledger/ui';
import { CellText, makeLinkCell, makeSerialCell } from '@/components/common';
import { CERTIFICATE_TYPE_TONE } from '@/config/statusTones';
import { siteCertificateLabels } from '../mappers/sitesMappers';
import { SITE_COLUMNS, SITE_SORT_FIELDS } from './sites.constants';
import styles from './sitesColumns.module.scss';

const canSort = (id) => Boolean(SITE_SORT_FIELDS[id]);

const renderCertificates = (ctx) => {
  const certificates = siteCertificateLabels(ctx.row.certificates);
  if (!certificates.length) return <CellText>-</CellText>;

  return (
    <span className={styles.certificates}>
      {certificates.map(({ code, label }) => (
        <Badge key={code} variant={CERTIFICATE_TYPE_TONE[code]} size={BadgeSizes.sm}>
          {label}
        </Badge>
      ))}
    </span>
  );
};

export const buildSitesColumns = (t, { serialOffset = 0, onOpenSite } = {}) =>
  [
    {
      id: SITE_COLUMNS.serialNo,
      header: t('SITES_COL_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 80,
      cell: makeSerialCell(serialOffset),
    },
    {
      id: SITE_COLUMNS.siteName,
      header: t('FIELD_SITE_NAME'),
      type: TableCellTypes.custom,
      width: 160,
      pinnable: true,
      cell: makeLinkCell(onOpenSite),
    },
    {
      id: SITE_COLUMNS.siteId,
      header: t('FIELD_SITE_ID'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: SITE_COLUMNS.certificates,
      header: t('SITES_COL_ASSOCIATED_CERTIFICATE'),
      type: TableCellTypes.custom,
      width: 180,
      cell: renderCertificates,
    },
    {
      id: SITE_COLUMNS.siteTypes,
      header: t('SITES_COL_SITE_TYPES'),
      type: TableCellTypes.text,
      width: 200,
    },
    {
      id: SITE_COLUMNS.terminalCount,
      header: t('SITES_COL_ASSOCIATED_TERMINALS'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: SITE_COLUMNS.materialCount,
      header: t('SITES_COL_ASSOCIATED_MATERIALS'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: SITE_COLUMNS.processCount,
      header: t('SITES_COL_ASSOCIATED_PROCESSES'),
      type: TableCellTypes.text,
      width: 160,
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
